<template>
  <v-autocomplete
    v-bind="$attrs"
    :ref="name"
    :multiple="multiple"
    :items="translatedItems"
    :chips="multiple"
    :value="value"
    v-on="$listeners"
  >
  </v-autocomplete>
</template>

<script>
export default {
  name: 'nx-select',
  props: {
    name: String,
    value: {
      type: [Array, String, Number],
    },
    items: {
      type: Array,
      required: true,
    },
    limit: {
      type: Number,
      required: false,
      default: 1,
    },
    translate: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    multiple() {
      return this.limit !== 1;
    },
    translatedItems() {
      if (!this.translate) return this.items;
      return this.items.map(item => ({
        value: item,
        text: this.$t(`message.form.formSelect.${item}`),
      }));
    },
  },
};
</script>
